import { useQuery } from '@apollo/client'
import { useEffect, useState } from 'react'
import { backendV2 } from '../../graphql/ClientGraphql'
import { HotPoolsData, HotPoolsVars, HOT_POOLS_QUERY } from '../../graphql/nftfy/backend/rockpool/HotPoolsCollectionQuery'
import { useGlobalConfig } from '../ConfigHook'

export const useHotPools = (chainId: number) => {
  const { paginationLimit } = useGlobalConfig()
  const [offset, setOffset] = useState<number>(0)
  const [hasMore, setHasMore] = useState<boolean>(true)
  const { loading, data, fetchMore, error } = useQuery<HotPoolsData, HotPoolsVars>(HOT_POOLS_QUERY, {
    client: backendV2,
    variables: {
      chainId,
      limit: paginationLimit,
      offset
    }
  })

  const loadMore = async () => {
    if (hasMore && !loading) {
      const isLoaded = (data?.rockpoolHotPoolItems.length || 0) - paginationLimit >= paginationLimit
      const newOffset = offset + paginationLimit
      const nextPageResult = await fetchMore({
        variables: {
          offset: isLoaded ? data?.rockpoolHotPoolItems.length || 0 : newOffset
        }
      })
      setOffset(newOffset)
      setHasMore(nextPageResult.data.rockpoolHotPoolItems.length === paginationLimit)
    }
  }

  useEffect(() => {
    setOffset(0)
    setHasMore(true)
  }, [chainId])

  useEffect(() => {
    if (error) {
      throw error
    }
  }, [error])

  return { hotPools: data?.rockpoolHotPoolItems || [], hotPoolsLoading: loading, loadMore }
}
